import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import { sxTypographyAdvice, sxTypographyAdviceTitle } from "./sxProps";

const AdviceContainerPaVirtual: React.FC = () => {
    return (
        <div className='advice-container'>
            <div className='advice-icon-holder'>
                <FontAwesomeIcon icon={faTriangleExclamation} className='far-triangle-exclamation' />
            </div>
            <div className='advice-text'>
                <Typography sx={sxTypographyAdviceTitle}>TRIAGEM ENCERRADA</Typography>
                <Typography sx={sxTypographyAdvice}>
                    O serviço PA Virtual foi elaborado para antender casos específicos e de baixa complexidade. 
                    Pedimos para que procure o pronto atendimento mais próximo ou orientação por telefone em caso de emergência.
                </Typography>
            </div>
        </div>
    )
}

export default AdviceContainerPaVirtual;